import { c as _c } from "react/compiler-runtime";
import { SchoolCard } from '@systemeio/light-lecture-viewer';
import { useCallback } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { CourseEditApiInterface } from 'modules/courses/courses/types/course-interface';
import { LightCourseCurriculumInterface } from 'modules/courses/courses/light-course/light-course-interface';
import { useStorePreviewContext } from '../../../../../context/store-preview-context';
export const useCoursePreview = () => {
  const $ = _c(7);
  const {
    setSingleItemMode,
    setPreview,
    lightLectureCss
  } = useStorePreviewContext();
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== lightLectureCss || $[1] !== setPreview || $[2] !== setSingleItemMode || $[3] !== t) {
    t0 = (courseData, courseCurriculumData) => {
      setSingleItemMode(true);
      const instructorName = courseData?.instructorName || t("dashboard.course.instructor_name_title");
      const courseCover = courseData?.image?.path || null;
      const title = courseData?.name || t("dashboard.light_course.course_title");
      const description = courseData?.description || t("dashboard.course.description_title");
      const totalLecturesCount = courseCurriculumData?.modules?.length || 0;
      setPreview([<div className="mx-5 p-5" key="preview-course"><div style={{
          width: "300px"
        }}><style>{"\n        body, .frame-content {\n          background-color: var(--color-background-primary) !important;\n        }\n      " + lightLectureCss}</style><SchoolCard variant="white" description={description} instructorName={instructorName} courseCover={courseCover} title={title} progress={0} completedLecturesCount={0} totalLecturesCount={totalLecturesCount} accessFrom="course" href={null} target={null} userTimeFormat={null} /></div></div>]);
    };
    $[0] = lightLectureCss;
    $[1] = setPreview;
    $[2] = setSingleItemMode;
    $[3] = t;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const showCoursePreview = t0;
  let t1;
  if ($[5] !== showCoursePreview) {
    t1 = {
      showCoursePreview
    };
    $[5] = showCoursePreview;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};